import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Observable } from 'rxjs'
import { filter, map, take } from 'rxjs/operators'
import { AuthService } from 'src/app/login/services/auth.service'
import { isAuthorizedAction } from 'src/assets/helpers/helper'

/**
 * Gates the dashboard route on the user's permissions. Runs after AuthGuard
 * has confirmed the user is logged in, so here we only verify that the user is
 * actually authorized to open the dashboard. A user without DASHBOARD or
 * MY_DASHBOARD is redirected to charge-history instead of landing on a view
 * they cannot use.
 *
 * Note: this is a client-side UX gate only. Authorization must still be
 * enforced by the backend on every dashboard data request.
 */
@Injectable({
  providedIn: 'root'
})
export class DashboardGuard {
  constructor (private authService: AuthService, private router: Router) {}

  public canActivate (): Observable<boolean> {
    return this.authService.permissions$.pipe(
      //wait for the real permissions to arrive before deciding
      filter((p) => !!p && p.length > 0),
      take(1),
      map((p) => {
        const authorized =
          isAuthorizedAction(p, 'DASHBOARD') ||
          isAuthorizedAction(p, 'MY_DASHBOARD')
        if (!authorized) {
          this.router.navigate(['/charge-history'])
        }
        return authorized
      })
    )
  }
}
